import React, { useCallback, useRef, Fragment, ReactNode } from "react";

import { IonItem, IonSpinner } from "@ionic/react";

interface useInfiniteOptions {
  loading: boolean;
  hasMore: boolean;
  setPage(value: any): any;
}

const useInfinite = ({ loading, hasMore, setPage }: useInfiniteOptions) => {
  const observer = useRef<IntersectionObserver>();
  const refElLast = useCallback(
    (node) => {
      if (loading) return false;
      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          setPage((prevPage: any) => prevPage + 1);
        }
      });
      if (node) observer.current.observe(node);
    },
    [hasMore, loading, setPage]
  );

  return {
    refElLast,
  };
};

interface IonItemsInfiniteProps {
  items: any[];
  render: (item: any) => ReactNode;
  refItem: (event: any) => void;
  onClick: (row: any, event: any) => void;
  ionItemProps?: IonItemProps;
  loading?: boolean;
}

interface IonItemProps {
  button: boolean;
  lines?: "none" | "full" | "inset";
}

const IonItemsInfinite: React.FC<IonItemsInfiniteProps> = ({
  items,
  render,
  refItem,
  onClick,
  ionItemProps,
  loading = false,
}) => {
  return (
    <Fragment>
      {items.map((row: any, index: number) => {
        if (items.length === index + 1) {
          return (
            <IonItem
              key={`item-${index}`}
              {...ionItemProps}
              onClick={(event) => onClick(row, event)}
              ref={refItem}
            >
              {render(row)}
            </IonItem>
          );
        }
        return (
          <IonItem
            key={`item-${index}`}
            {...ionItemProps}
            onClick={(event) => onClick(row, event)}
          >
            {render(row)}
          </IonItem>
        );
      })}
      {loading ? (
        <div className="loading">
          <IonSpinner className="loading" />
          <span>Carregando...</span>
        </div>
      ) : null}
    </Fragment>
  );
};

export { IonItemsInfinite };

export default useInfinite;
